import React from "react";
import Image from "next/image";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";

const UspVisitPoweredByMobile = () => {
  return (
    <>
      <div className="w-full md:pt-[60px] pt-[30px] md:pb-[80px] pb-[30px] bg-[#0C1F33] relative">
        <Image
          src="/images/accounting/usp/Payment-mount.png"
          alt="Special Offer"
          className="mx-auto absolute md:bottom-0 bottom-0 left-0 w-full z-[0]"
          width={360}
          height={327}
          priority
        />

        <div
          className="p-4 border border-white rounded-2xl mx-4"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
            boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
            backdropFilter: "blur(28px)",
          }}
        >
          <Image
            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
            alt="star group"
            width={34}
            height={38}
            className="absolute top-1 left-0"
          />
          <GlobalForm
            course="USP"
            courseId={3}
            formHeading={FormHeading.WORLD_FAVORITE_CMA_CPA_INSTRUCTOR}
            formType="page"
            isAStepperForm={true}
            pageType="business page"
            subCategory={FinanceAndAccountingSubcategory.USP}
            submitButtonName="Download Brochure"
            successMessage={SuccessMessageType.ACCOUNTING}
            verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
            showSVG={false}
            darkBackground={true}
          />
        </div>
      </div>
    </>
  );
};

export default UspVisitPoweredByMobile;
